import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import LoginGate from "@/components/LoginGate";
import ErrorBoundary from "@/components/ErrorBoundary";
import { I18nProvider } from "@/lib/i18n";
import { reportClientError } from "@/lib/api";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Errores que ocurren fuera de React (eventos, promesas): se informan al servidor para poder diagnosticarlos.
window.addEventListener("error", (e) =>
  reportClientError({ message: e.message, stack: e.error?.stack, kind: "window-error" })
);
window.addEventListener("unhandledrejection", (e) =>
  reportClientError({ message: String(e.reason?.message || e.reason), stack: e.reason?.stack, kind: "unhandled-rejection" })
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <I18nProvider>
        <ErrorBoundary>
          <LoginGate>
            <App />
          </LoginGate>
        </ErrorBoundary>
      </I18nProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
